import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { Collapse } from 'react-collapse';
import { append, map, defaultTo, prop, addIndex, remove, any, propEq, sortWith, descend, update } from 'ramda';
import moment from 'moment';

import { formatDate } from 'lib/dateDisplay';
import { valueStyle } from './CEvents.less';

import TextField from 'components/MaterialTextField';
import ActionButton from 'components/ActionButton';

const mapIndexed = addIndex(map);

const fields = [
  'mobility',
  'clothing',
  'hygiene',
  'eating',
  'communication',
  'cognition',
  'medicationAndCare',
  'dailyMatters',
];

const makeEvent = () => ({
  date: moment().toDate(),
  timestamp: moment().valueOf(),
  done: false,
});

const sortEvents = sortWith([descend(prop('timestamp')), descend(propEq('done', false))]);

const isEditing = any(propEq('done', false));

const AddNewWrapper = ({ onAddNew }) => (
  <Row>
    <Col xs>
      <ActionButton localeId="dictionary.addNew" secondary border onClick={onAddNew} />
    </Col>
  </Row>
);

AddNewWrapper.propTypes = {
  onAddNew: PropTypes.func.isRequired,
};

const RenderEdit = ({ id, editing, value, onChange, onRemove, onDone, localeMessage }) => (
  <Row>
    <Col xs>
      {editing && (
        <p className="bold" style={{ marginBottom: '1em' }}>
          {localeMessage('benefits.statement.instruction')}
        </p>
      )}
      {map(f => (
        <div key={f} style={{ marginBottom: '2rem' }}>
          <Row style={{ marginBottom: '0.5em' }}>
            <Col xs>
              <p>{localeMessage(`benefits.statement.labels.${f}`)}</p>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              {editing && (
                <TextField
                  name={`cstatement_${id}_${f}`}
                  multiLine
                  fullWidth
                  value={prop(f, value)}
                  onChange={(e, v) => onChange(id, f, v)}
                />
              )}
              {!editing && <p className={valueStyle}>{prop(f, value) || null}</p>}
            </Col>
          </Row>
        </div>
      ))(fields)}
      {editing && (
        <Row>
          <Col xs={5} sm={4} md={3}>
            <ActionButton localeId="dictionary.save" secondary border onClick={() => onDone(id)} />
          </Col>
          <Col xs={5} sm={4} md={3}>
            <ActionButton localeId="dictionary.cancel" secondary onClick={() => onRemove(id)} />
          </Col>
        </Row>
      )}
    </Col>
  </Row>
);

RenderEdit.propTypes = {
  id: PropTypes.number.isRequired,
  editing: PropTypes.bool.isRequired,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  localeMessage: PropTypes.func.isRequired,
};

class CEvents extends Component {
  constructor(props) {
    super(props);
    this.state = { open: null };
    this.getValue = () => sortEvents(defaultTo([], this.props.input.value));
    this.handleChange = value => this.props.input.onChange(value);
    this.handleSubFieldChange = (id, key, value) => {
      const thisCForm = this.getValue()[id];
      this.handleChange(update(id, { ...thisCForm, [key]: value }, this.getValue()));
    };
    this.handleAddNew = () => this.handleChange(append(makeEvent(), this.getValue()));
    this.handleRemove = id => this.handleChange(remove(id, 1, this.getValue()));
    this.setShowId = i => this.setState({ open: i });
    this.getShowId = () => (!isEditing(this.getValue()) ? defaultTo(0, this.state.open) : null);
    this.handleDone = id => {
      this.handleSubFieldChange(id, 'done', true);
      this.setShowId(id);
    };
  }

  render() {
    const { editing, localeMessage } = this.props;
    return (
      <div>
        {mapIndexed((d, i) => (
          <Row key={d.timestamp} style={{ marginBottom: '2rem' }}>
            <Col xs={12} sm={3} md={4} style={{ marginBottom: '2rem' }}>
              <p>{formatDate(d.date)}</p>
            </Col>
            <Col xs={12} sm={8} smOffset={1} md={7} mdOffset={1}>
              <Collapse isOpened={isEditing(this.getValue()) ? !d.done : i === this.getShowId()}>
                <RenderEdit
                  id={i}
                  editing={editing && !d.done}
                  value={d}
                  onChange={this.handleSubFieldChange}
                  onDone={this.handleDone}
                  onRemove={this.handleRemove}
                  localeMessage={localeMessage}
                />
              </Collapse>
              {!isEditing(this.getValue()) && (editing ? d.done && i !== this.getShowId() : i !== this.getShowId()) && (
                <ActionButton localeId="dictionary.show" secondary border condensed onClick={() => this.setShowId(i)} />
              )}
              {(editing ? d.done && i === this.getShowId() : i === this.getShowId()) && (
                <ActionButton
                  localeId="dictionary.hide"
                  secondary
                  border
                  condensed
                  onClick={() => this.setShowId(-1)}
                />
              )}
            </Col>
          </Row>
        ))(this.getValue())}
        {editing && !isEditing(this.getValue()) && (
          <Row>
            <Col xs={12} sm={6} smOffset={6} md={7} mdOffset={5}>
              <AddNewWrapper onAddNew={this.handleAddNew} />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

CEvents.propTypes = {
  editing: PropTypes.bool.isRequired,
  localeMessage: PropTypes.func.isRequired,
  input: PropTypes.object.isRequired,
};

export default CEvents;
